import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import './Button.css';

/**
 * Button Component
 *
 * @author Phil Winfield <pwinfield@wearearchitect.com>
 */
export default class Button extends Component {

    /**
     * Default Props
     *
     * @type {{}}
     */
    static defaultProps = {
        buttonText: 'Play video',
        link: '/contact'
    };

    /**
     * Prop Types
     *
     * @type {{}}
     */
    static propTypes = {
        buttonText: PropTypes.string,
        link: PropTypes.string
    };

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {buttonText, link} = this.props;

        return (
            <button>
                <Link to={link}>{buttonText}</Link>
            </button>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/global/button/Button.jsx